import {axios as http} from "@/plugins/http"
import QuerySerializer from "@/services/QuerySerializer"

export default class Api {
    static delete(wishId) {
        return http.post("/api/v1/wishlist/delete-wish", null, {
            params: {
                wish_ids: [wishId],
            },
            paramsSerializer: (params) => QuerySerializer.stringify(params),
        }).then((resp) => {
            return resp.data;
        });
    }
}
